"use client";

import { ArrowLeftCircleIcon, ArrowRightCircleIcon } from "@heroicons/react/24/solid";

const ArrowIcon = ({ direction, variant }) => {
  if (variant === "mobile") {
    const CircleArrow = direction === "prev" ? ArrowLeftCircleIcon : ArrowRightCircleIcon;
    return <CircleArrow className="w-10 h-10" aria-hidden="true" />;
  }
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d={direction === "prev" ? "M15.75 19.5L8.25 12L15.75 4.5" : "M8.25 4.5L15.75 12L8.25 19.5"}
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const VARIANT_CLASSES = {
  desktop: "bg-white border-2 border-sand text-sea disabled:opacity-60",
  mobile: "text-white drop-shadow-md",
};

const NavButton = ({ direction, onClick, disabled, className = "", variant = "desktop" }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className={`w-10 h-10 shrink-0 flex items-center justify-center transition-all rounded-full hover:scale-105 disabled:cursor-not-allowed cursor-pointer ${VARIANT_CLASSES[variant]} ${className}`}
    aria-label={direction === "prev" ? "Previous image" : "Next image"}
  >
    <ArrowIcon direction={direction} variant={variant} />
  </button>
);

export default NavButton;
